import UbahSPK from './UbahSPK'

export default UbahSPK